
import { useEffect,useState } from "react";
// import "../NavBar/NavBar.css"

import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useAuth from "../../Hooks/UseAuth";



   

function PTOReports(){  

    const[tData, setTData] = useState([]);
    const [searchData, setSearchData] = useState(""); 
    const axiosPrivate = useAxiosPrivate();
    const auth = useAuth();



      async function populateData(){  
        const queryParams = { Org : auth.auth.foundUser.Org};
        const queryString = new URLSearchParams(queryParams).toString();

        console.log(queryString)

            // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
            // const response = await fetch("https://nerdayb.onrender.com/api/PTOReports",{
            // const response = await fetch(`http://localhost:2001/api/OrgPTOReports?${queryString}`,{
            const response = await fetch(`https://nerdayb.onrender.com/api/OrgPTOReports?${queryString}`,{
                headers : { 
                //   'x-access-token' : auth.user,
                }
            // body: JSON.stringify({
            //     quote,
                
            // })
            })
            
            const data = await response.json();
            console.log("All Data here",data.propdata)
            if(data){

        if(data.status == "ok") {
            setTData(data.propdata)
            setSearchData(data.propdata)
            }else{
            //    alert(data.error,"Here!")
            console.log("testign first")
            } 

        }
        
      //   console.log(data,"aync test");
        
        return data;
        
  } 

  useEffect(()=>{ 

     populateData();
     console.log("test populate");

  },[]) 

    return <>

        <div  className="CompensationCard">

                <div className="cardHeading"><h2>PTO Reports</h2></div>
                <div className="compensationCard">
                   
                    <table className="contentTable"> 
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Requester</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Days</th>
                                <th>Purpose</th> 
                                <th>Balance</th> 
                               
                            </tr>
                        </thead>
                        {tData && tData.map((Item,key)=>{
                            return(
                                <>
                                     <tbody>
                                            <tr>
                                                <td>{String(Item.Date).substring(0,10)}</td>
                                                <td>{Item.RequestorName}</td>
                                                <td>{String(Item.StartDate).substring(0,10)}</td>
                                                <td>{String(Item.EndDate).substring(0,10)}</td>
                                                <td>{Item.Count}</td>
                                                <td>{Item.Purpose}</td>
                                                <td>{Item.BalanceCount}</td>
                                               
                                                
                                            </tr>
                                         
                                        </tbody>
                                                
                                </>
                            )
                        })}
                       
                    </table>

                </div>
         
           
        </div>
        
    
    </>

}

export default PTOReports;